"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cardRowStyle", {
  enumerable: true,
  get: function get() {
    return _TableList2.cardRowStyle;
  }
});
Object.defineProperty(exports, "cardWrapperStyle", {
  enumerable: true,
  get: function get() {
    return _TableList2.cardWrapperStyle;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "headerResultsTextStyle", {
  enumerable: true,
  get: function get() {
    return _TableList2.headerResultsTextStyle;
  }
});
Object.defineProperty(exports, "headerTableStyle", {
  enumerable: true,
  get: function get() {
    return _TableList2.headerTableStyle;
  }
});
Object.defineProperty(exports, "linkStyles", {
  enumerable: true,
  get: function get() {
    return _TableList2.linkStyles;
  }
});
Object.defineProperty(exports, "loadMoreStyles", {
  enumerable: true,
  get: function get() {
    return _TableList2.loadMoreStyles;
  }
});
Object.defineProperty(exports, "resultContainerStyle", {
  enumerable: true,
  get: function get() {
    return _TableList2.resultContainerStyle;
  }
});
Object.defineProperty(exports, "resultRowCellStyle", {
  enumerable: true,
  get: function get() {
    return _TableList2.resultRowCellStyle;
  }
});
Object.defineProperty(exports, "tableStyle", {
  enumerable: true,
  get: function get() {
    return _TableList2.tableStyle;
  }
});
var _TableList = _interopRequireDefault(require("./TableList.component"));
var _TableList2 = require("./TableList.style");
var _default = exports.default = _TableList.default;